var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrechingHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5573 15.25L15.5799 14.6585C16.7445 13.9847 17.3263 13.6478 17.4043 13.1678C17.4158 13.0929 17.4194 13.0171 17.4151 12.9414C17.3761 12.4583 16.8236 12.0856 15.7197 11.3403M15.7197 11.3403L10.6204 7.8985M15.7197 11.3403L13.4881 9.83333C12.7368 10.8056 12.0939 11.8568 11.5706 12.9685C11.0939 13.9728 10.8567 14.4743 10.9011 15.0485L7.66732 14.1667M10.6204 7.8985C8.61736 6.5465 8.15694 4.08083 9.56311 2.25M10.6204 7.8985C7.91211 10.6068 6.58398 18.1013 6.58398 21.75M10.6204 7.8985L13.487 9.83333M15.2507 21.75C14.1966 20.5204 13.1122 18.825 12.0548 17.2628C11.3149 16.1687 10.9444 15.6205 10.9011 15.0474M16.3339 4.95833C16.3339 5.38931 16.1627 5.80264 15.858 6.10738C15.5532 6.41213 15.1399 6.58333 14.7089 6.58333C14.278 6.58333 13.8646 6.41213 13.5599 6.10738C13.2551 5.80264 13.0839 5.38931 13.0839 4.95833C13.0839 4.52736 13.2551 4.11403 13.5599 3.80928C13.8646 3.50454 14.278 3.33333 14.7089 3.33333C15.1399 3.33333 15.5532 3.50454 15.858 3.80928C16.1627 4.11403 16.3339 4.52736 16.3339 4.95833Z",
    stroke: "#1C492D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrechingHuman);
export default __webpack_public_path__ + "static/media/strechingHuman.78d74890930ff5f63a6aa629f99e2adc.svg";
export { ForwardRef as ReactComponent };